import 'ng-csv';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './campaignsTable.jade';

// The table filters, sorts and paginates client-side, so the statistics request has to bring back
// every campaign of the game in a single page rather than just the rows currently on screen.
const STATISTICS_PAGE_SIZE = 1000;

export class CampaignsTableController {
  /* @ngInject */
  constructor($stateParams,GamesResource,CampaignsResource,CampaignAnalyticsResource,CampaignsOverviewByGameResource,$filter,$localStorage,notify){
    this.$stateParams = $stateParams;
    this.GamesResource = GamesResource;
    this.CampaignsResource = CampaignsResource;
    this.CampaignAnalyticsResource = CampaignAnalyticsResource;
    this.CampaignsOverviewByGameResource = CampaignsOverviewByGameResource;
    this.translate = $filter('translate');
    this.apiDate = $filter('apiDate');
    this.notify = notify;
    this.$localStorage = $localStorage;

    this.timeframe = normalizeTimeframe(this.timeframe || this.$localStorage.timeframe);
    this.timeframeChange = this.timeframeChange || new Rx.BehaviorSubject(this.timeframe);
    this.timeframeChange.subscribe((timeframe) => {
      this.timeframe = timeframe;
      this.getCampaignsStatistics();
    });
    this.getCampaigns({game_id: $stateParams.gameId, segment_id: $stateParams.id});
    this.getCurrency();
  }

  getCampaigns({game_id,segment_id}) {
    return this.CampaignsResource.getList({game_id,segment_id})
        .then(campaigns => { this.campaignsTable.loadData(campaigns); })
        .then(() => this.getCampaignsStatistics())
  }

  getCurrency() {
    this.currency = 'USD';
  }

  isAcquisitionTypeCampaign(campaign) {
    // Acquisition metrics were removed in PEP-4438; only ROI is still shown for these.
    return campaign.type == 'Acquisition' || campaign.type == 'AcquisitionCPM' || campaign.type == 'BrandingCPM';
  }

  getCampaignsStatistics(){
    const campaigns = this.campaignsTable.loadedData || [];
    if (!campaigns.length) {
      return;
    }

    campaigns.forEach(campaign => {
      if (!this.isAcquisitionTypeCampaign(campaign)) {
        campaign.roi_d7 = 'Loading...';
      }
    });

    return this.CampaignsOverviewByGameResource.one().get({
      game_id: this.$stateParams.gameId,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      page: 1,
      count: STATISTICS_PAGE_SIZE
    }).then(res => {
      const rowsByCampaignId = _.keyBy(res.items || [], 'campaign_id');
      campaigns.forEach(campaign => this.applyCampaignStatistics(campaign, rowsByCampaignId[campaign.id]));
    });
  }

  applyCampaignStatistics(campaign, row) {
    campaign.roi_d7 = row && this.isNumeric(row.roi_d7) ? row.roi_d7 : 0;

    if (!row || this.isAcquisitionTypeCampaign(campaign)) {
      return;
    }

    campaign.impressions = row.impressions;
    campaign.ecpm = row.ecpm;
    campaign.click_through_rate = row.click_through_rate;
    campaign.clicks = row.clicks;
    campaign.ecpc = row.ecpc;
    campaign.conversion_rate = row.conversion_rate;
    campaign.conversions = row.engaged_players;
    campaign.ecpe = row.ecpe;
    campaign.cost = row.cost;
    campaign.ecpi = row.ecpi;
    campaign.app_open = row.app_open;
  }

  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  isBudgetCappingTypeMonetary() {
    return this.campaign.budget_capping_type == 'Monetary';
  }

  isBudgetCappingTypeClicks() {
    return this.campaign.type == 'EngagementCPC' && this.campaign.budget_capping_type == 'Event';
  }

  isBudgetCappingTypeConversions() {
    return this.campaign.type == 'EngagementCPA' && this.campaign.budget_capping_type == 'Event';
  }

  isEngagementTypeCampaign() {
    return this.campaign.type == "Engagement" || this.campaign.type == "EngagementCPC" || this.campaign.type == "EngagementCPA"
  }

  isCampaignOfPlatformType(campaign, value) {
    return campaign.urls && campaign.urls[value];
  }

  getAutoPilotStyle(campaign) {
    if (campaign.autopilot_launcher_message !== null) {
      return {
        'text-decoration': 'line-through',
        'text-decoration-color': 'rgba(240, 255, 0, 0.6)',
        'text-decoration-thickness': '0.4em'
      }
    }
    return {};
  }
}

export function CampaignsTableComponent() {
  return {
    template,
    controller: CampaignsTableController,
    transclude: true,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      campaignsTable: '=',
      timeframeChange: '=?',
      segment: '=?'
    },
    bindToController: true,
    link: function(scope,element,attrs,ctrl, transclude) {
      element.find('ng-transclude').replaceWith(transclude());
    }
  };
};

export default angular.module('app.components.segments.campaigns.index', [
  'ngCsv',
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
.directive('campaignsTable', CampaignsTableComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsTable.js
 **/